module.exports = __webpack_public_path__ + "media/images/svg-icon/maps-57ef1c98536cea0136233c00d35a9097.svg";